export default {
  state: {
    theme_active: {
      name: "sneakers_of_creator",
      title: "Кеды создателя",
      colors: ["#fff7e1", "#52a3ca", "#fd9e80", "#5d55ad"],
    },
    themes: [
      {
        name: "sneakers_of_creator",
        title: "Кеды создателя",
        colors: ["#fff7e1", "#52a3ca", "#fd9e80", "#5d55ad"],
      },
      {
        name: "dark",
        title: "Темная тема",
        colors: ["#fff7e1", "#52a3ca", "#fd9e80", "#5d55ad"],
      },
    ],
  },
  mutations: {
    setActiveTheme(state, active) {
      state.theme_active = active;
      localStorage.setItem('theme', active.name)
    },
    findAndSetTheme(state, active) {
      state.theme_active = state.themes.find(theme => theme.name == active);
    },
  },
  actions: {
    setTheme({ commit }, value) {
      commit("setActiveTheme", value);
    },
    findAndSetTheme({ commit }, value) {
      commit("findAndSetTheme", value);
    }
  },
  getters: {
    getActiveTheme: (s) => s.theme_active,
    getThemes: (s) => s.themes,
  },
};
